import React from "react";
import OutlineButton from "../../../../../../components/OutlineButton/OutlineButton";
import { Typography } from "@material-ui/core";
// import moment from "moment-timezone";
import { useDispatch } from "react-redux";
import { doGetCancelFirmwareUpdate, doGetUpdateDetails } from "../../../../../../redux/thunks/readers";
import { useParams } from 'react-router-dom';
import { convertToHex } from "../../../../../../helpers/renderers";
import SButton from "../../../../../../components/SButton/SButton";

const UpdateDetail = ({ readerDetails, sites }) => {

    const dispatch = useDispatch();

    const { customerId } = useParams();

    const renderStatus = () => {
        switch (readerDetails?.updateStatus) {
            case 1:
                return <Typography className="ud-status" style={{ color: "#15D141" }} variant="body2">Updating to {convertToHex(readerDetails?.updateToPdSwVer)} ({readerDetails?.updateProgress}%)</Typography>
            case 3:
                return <Typography className="ud-status" style={{ color: "#FF0101" }} variant="body2">Failed to update to {convertToHex(readerDetails?.updateToPdSwVer)}</Typography>
            case "cancelled":
                return <Typography className="ud-status" style={{ color: "#E59D20" }} variant="body2">Cancelled update to {convertToHex(readerDetails?.updateToPdSwVer)}</Typography>
            case 0:
                return (
                    <>
                        {/* <Typography className="ud-status" variant="body2">Scheduled for {moment(readerDetails?.scheduleTime).format("MMMM DD YYYY, hh:mm A")}</Typography> */}
                        <Typography className="ud-status" variant="body2">Updating to {convertToHex(readerDetails?.updateToPdSwVer)}</Typography>
                    </>
                )
            default:
                break;
        }
    }

    const processUpdate = () => {
        if (readerDetails?.updateStatus === 3) {
            //IF UPDATE FAILS
        } else {
            dispatch(doGetCancelFirmwareUpdate(
                {
                    serialNumbers: [readerDetails?.serialNumber]
                },
                customerId,
                () => {
                    dispatch(doGetUpdateDetails({ sites: sites }, customerId))
                }
            ))
        }
    }

    return (
        <div className="update-details-container">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <div className="ud-inner-container">
                    <p className="ud-name">{readerDetails?.accessPoint}</p>
                    <p className="ud-version">{convertToHex(readerDetails?.currentPdSwVer)}</p>
                </div>
                {renderStatus()}
            </div>
            {readerDetails?.updateStatus !== 3 && <SButton variant={"secondary"} color={"error"} onClick={processUpdate}>Cancel</SButton>}
        </div>
    )
};

export default UpdateDetail;